export class FieldValidationMessage {
    validationName: string;
    message: string;
    messageParams: any;

    constructor(validationName: string, message: string, messageParams: any = {}) {
        this.validationName = validationName;
        this.message = message;
        this.messageParams = messageParams;
    }
}



// WEBPACK FOOTER //
// ./src/app/inputs/field/field-validation-message.ts